"use client";
import { useSelector } from "react-redux";

export default function PermissionGuard({ required, children, fallback = null }) {
    const { user } = useSelector((state) => state.auth);

    if (!user || !user.role || !user.role.permissions) {
        return fallback;
    }

    // Handle permissions whether they are a string (from DB/JSON) or already parsed array
    let permissions = [];
    try {
        if (typeof user.role.permissions === 'string') {
            permissions = JSON.parse(user.role.permissions);
        } else if (Array.isArray(user.role.permissions)) {
            permissions = user.role.permissions;
        }
    } catch (e) {
        console.error("Failed to parse permissions", e);
        return fallback;
    }

    if (permissions.includes(required)) {
        return <>{children}</>;
    }

    return fallback;
}
